module.exports = __webpack_public_path__ + "assets/img/block-right-be697af0.png";